module.exports = "/assets/data/3d0a1221ddbd30cba9417bacdd17afe7-ZE2.data.json";